import React from 'react';
import { Warning } from '../../../atoms/membership_plans/Warning';
import './planUpdateWarning.module.scss';

export const PlanUpdateWarning = () => {
  const url = 'https://support.she-inc.jp/hc/ja/articles/1500002597221';
  return (
    <div styleName="plan-update-warning">
      <Warning id="plan-update-warning">
        ▼プラン変更のお手続き期限に関して
        <br />
        ・プランを変更する場合、次回お支払い日の10日前までにお申し込みください。
        <br />
        ※10日前を過ぎてプラン変更をお申し込みいただいた場合次々回からの変更適応となります。
        <br />
        <br />
        ▼休会復帰後のプラン変更をご希望の場合に関して
        <br />
        ・休会復帰日の10日前までに
        <a href={url} target="_blank">
          SHElikes公式LINE
        </a>
        までお問い合わせください。
        <br />
        システム上ご自身でのお手続きができない為、弊社にてお手続きをさせていただきます。
        <br />
        <br />
        ▼6ヶ月目・12ヶ月目（プラン満了直後）からの休会をご希望の場合に関して
        <br />
        ・10日前までに
        <a href={url} target="_blank">
          SHElikes公式LINE
        </a>
        までお問い合わせください。
        <br />
        システム上ご自身でのお手続きができない為、弊社にてお手続きをさせていただきます。
        <br />
        <br />
        ▼プラン変更中の退会・休会をご希望の場合に関して
        <br />
        ・プラン変更中の退会・休会申請はお受けできません。プラン変更を取り消していただき、申請をお願いいたします。
      </Warning>
    </div>
  );
};
